import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import styled from "styled-components";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

const HeaderTable = styled.div`
    text-align:center;
    color:#041E42;
    font-size:24px;
`

const IconHeader = styled(RequestQuoteIcon)`
    vertical-align:text-bottom;
    margin-right:10px;
    width: 30px !important;
    height: 30px !important;
`

const HeaderTitulo = styled.span`
    vertical-align:text-bottom;
    margin-bottom:10px;
`

const TabelaNotasFiscais = (props) => {

    const [notas, setNotas] = useState([]);
    const [tipoProduto, setTipoProduto] = useState("TERRESTRE")

    useEffect(() => {
        setNotas(props.fatura.notas);
        setTipoProduto(props.tipoProduto);
    }, [notas, props, tipoProduto]);

    const header = (
        <HeaderTable>
            <p><IconHeader/><HeaderTitulo>NOTA FISCAL</HeaderTitulo></p>
        </HeaderTable>
    );

    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options)
    
    const enderecoBodyTemplate  = (rowData) => {
        let endereco = 
        <div>
            <p>{rowData.nome}</p>
            <p>{rowData.endereco}</p>
            <p>{rowData.cidade} - {rowData.uf}</p>
            <p>CNPJ: {rowData.cnpj} - IE: {rowData.ie}</p>
        </div>
        return endereco;
    }

    const valorNacionalBodyTemplate = (rowData) => {   
        let value = rowData.valorNacional;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const valorInternacionalBodyTemplate = (rowData) => {
        let value = rowData.valorInternacional;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const valorNotaBodyTemplate = (rowData) => {
        let value = rowData.valor;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const valorISSRFBodyTemplate = (rowData) => {
        let value = rowData.issrf;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }
    return (
        <>
        { tipoProduto !== 'TERRESTRE' ? 
            <DataTable header={header} size="small" stripedRows value={notas} responsiveLayout="scroll" rowGroupMode="subheader" 
                sortMode="single" sortOrder={1} scrollable scrollHeight="500px" scrollDirection="both" >
                 
                <Column bodyStyle={{ width: '10%' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '10%' }} field="cia" header="Cia"></Column>
                <Column bodyStyle={{ width: '46%' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '46%' }} field={enderecoBodyTemplate} header="Dados do Fornecedor"></Column>
                <Column bodyStyle={{ width: '10%', marginLeft:'25px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '10%' }} field={valorNacionalBodyTemplate} header="Comissão"></Column>
                <Column bodyStyle={{ width: '10%'  }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '10%' }} field={valorInternacionalBodyTemplate} header="Incentivo"></Column>
                <Column bodyStyle={{ width: '12%'  }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '12%' }} field={valorNotaBodyTemplate} header="Valor da NF"></Column>
                <Column bodyStyle={{ width: '12%'  }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '12%' }} field={valorISSRFBodyTemplate} header="Valor ISSRF"></Column>
            </DataTable>
            : 
            <DataTable header={header} size="small" stripedRows value={notas} responsiveLayout="scroll" rowGroupMode="subheader" 
                sortMode="single" sortOrder={1} scrollable scrollHeight="500px" scrollDirection="both" >
                 
                <Column bodyStyle={{ width: '66%' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '66%' }} field={enderecoBodyTemplate} header="Dados do Fornecedor"></Column>
                <Column bodyStyle={{ width: '10%' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '10%' }} field={valorNacionalBodyTemplate}  header="Comissão"></Column>
                <Column bodyStyle={{ width: '10%' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '10%' }} field={valorInternacionalBodyTemplate} header="Incentivo"></Column>
                <Column bodyStyle={{ width: '12%' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '12%' }} field={valorNotaBodyTemplate} header="Valor da NF"></Column>
                <Column bodyStyle={{ width: '12%' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '12%' }} field={valorISSRFBodyTemplate} header="Valor ISSRF"></Column>
            </DataTable> }
        </>
    );
}

export default TabelaNotasFiscais;
